import { useUnit } from 'effector-react'
import {
  $tasks,
  $totalCountOfTasks,
  getTasksFx,
  $tasksTypes,
  getTaskTypesFx,
} from './model'

export const useTasksList = () => {
  const tasks = useUnit($tasks)
  const loading = useUnit(getTasksFx.pending)
  const totalCountOfTasks = useUnit($totalCountOfTasks)

  return { tasks, totalCountOfTasks, loading }
}

export const useTasksTypesList = () => {
  const tasksTypes = useUnit($tasksTypes)
  const loading = useUnit(getTaskTypesFx.pending)

  return { tasksTypes, loading }
}
